module.exports = __webpack_public_path__ + "img/settings.4c26d5fd.svg";